import _DashetsRpc from "@/server/com/silkplm/dashlets/_RpcIndex"

/**
 * @type {Dashlets}
 */
let DashetsRpc = new _DashetsRpc();
if(window) {
    window['DashetsRpc'] = DashetsRpc;
}

export default DashetsRpc;
